$(function () {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('.icon-chevron-down, button');
    var nav_align = 'right';
    var break_point = 992;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_wrap = $('.navwrap');

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        // nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    var nav_ul = $('.nav ul li > ul');
    
    function initMenu() {
        var browser_width = window.innerWidth;

         // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {
            $('.menu-item').focusin(function () {
                $(this).addClass('__active');
                $(this).children('button').attr('aria-expanded', true);
            });
            $('.menu-item').focusout(function () {
                $(this).removeClass('__active');
                $(this).children('button').attr('aria-expanded', false);
            });
            $('.menu-item').mouseover(function () {
                $(this).children('button').attr('aria-expanded', true);
            });
            $('.menu-item').mouseout(function () {
                $(this).children('button').attr('aria-expanded', false);
            });
        }

        if (browser_width < break_point) {
            nav_trigger.click(function (event) {
                const target = event.target.tagName.toLowerCase();
                event.stopPropagation();
                
                if (target === 'span') {
                    event.preventDefault();
                    $(event.target).parent().toggleClass('__active');  
                    $(event.target).parent().attr('aria-expanded', $(event.target).parent().attr('aria-expanded') === 'true' ? 'false' : 'true');
                    $(this).parent().siblings('ul').slideToggle(400);
                }
                
                if (target === 'button') {
                    $(event.target).toggleClass('__active');
                    $(event.target).attr('aria-expanded', $(event.target).attr('aria-expanded') === 'true' ? 'false' : 'true');
                    $(this).siblings('ul').slideToggle(400);
                }
            });
        }
        

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
        }

        var view_all = $('.viewall');
        view_all.each(function () {
            var parent_url = $(this)
                .closest('ul')
                .siblings()
                .attr('href');
            var parent_title = $(this)
                .closest('ul')
                .siblings()
                .html();
            $(this)
                .find('a')
                .attr('href', parent_url);
            $(this)
                .find('a')
                .html('View ' + parent_title);
        });

        view_all.click(function (event) {
            event.stopPropagation();
        });
    }
    
    initMenu();

    $(window).on('resize', function(){
        initMenu();
    });

});